import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "iconfont icon-shouqi"
}
const _hoisted_2 = {
  key: 1,
  class: "iconfont icon-zhankaicaidan"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_left_bold = _resolveComponent("arrow-left-bold")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isShrink? 'shou-menu active' : 'shou-menu')
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shrink && _ctx.shrink(...args))),
      style: {"width":"28px"}
    }, [
      (!_ctx.isShrink)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2))
    ]),
    (_ctx.$route.meta.showBack)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          style: {"font-size":"16px","display":"flex","align-items":"center"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_arrow_left_bold)
            ]),
            _: 1
          }),
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
  ], 2))
}